// extracted by mini-css-extract-plugin
export default {"container":"M4MvHK","responsive":"bCmoZB","button":"pLbLYE","rounded":"IixSeg","link":"jcWlHO","loading":"lrQ7rV"};